export default function initCopyBtn() {
  const btns = document.querySelectorAll('[data-copy]');

  btns.forEach((btn) => {
    const copyText = btn.dataset.copy;
    const successText = btn.dataset.copyText;

    if (!copyText) return;

    const initialHtml = btn.innerHTML;
    let resetTimer = null;

    const handleClick = async () => {
      try {
        await navigator.clipboard.writeText(copyText);
      } catch (_) {
        return;
      }

      if (successText) {
        btn.innerHTML = successText;
      }

      if (resetTimer) {
        clearTimeout(resetTimer);
      }

      resetTimer = setTimeout(() => {
        btn.innerHTML = initialHtml;
        resetTimer = null;
      }, 1000);
    }

    btn.addEventListener('click', handleClick);
  });
}
